import { Injectable } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  constructor(private primeNGConfig: PrimeNGConfig) {}

  setItalianTranslations(): void {
    this.primeNGConfig.setTranslation({
      accept: 'Accetta',
      reject: 'Rifiuta',
      choose: 'Scegli',
      upload: 'Carica',
      cancel: 'Annulla',
      dayNames: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
      dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
      dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
      monthNames: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
      monthNamesShort: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
      today: 'Oggi',
      clear: 'Pulisci',
      weekHeader: 'Sett',
      firstDayOfWeek: 1,
      dateFormat: 'dd/mm/yy',
      weak: 'Debole',
      medium: 'Media',
      strong: 'Forte',
      passwordPrompt: 'Inserisci una password',
      emptyFilterMessage: 'Nessun risultato trovato',
      emptyMessage: 'Nessuna opzione disponibile',
      emptySearchMessage: 'Nessun risultato trovato',
      aria: {
        trueLabel: 'Vero',
        falseLabel: 'Falso',
        nullLabel: 'Non selezionato',
        star: '1 stella',
        stars: '{star} stelle',
        selectAll: 'Tutti gli elementi selezionati',
        unselectAll: 'Tutti gli elementi deselezionati',
        close: 'Chiudi',
        previous: 'Precedente',
        next: 'Successivo',
        navigation: 'Navigazione',
        scrollTop: 'Scorri in alto',
        moveTop: 'Sposta in alto',
        moveUp: 'Sposta su',
        moveDown: 'Sposta giù',
        moveBottom: 'Sposta in basso',
        moveToTarget: 'Sposta nel target',
        moveToSource: 'Sposta nella sorgente',
        moveAllToTarget: 'Sposta tutto nel target',
        moveAllToSource: 'Sposta tutto nella sorgente',
        pageLabel: 'Pagina {page}',
        firstPageLabel: 'Prima pagina',
        lastPageLabel: 'Ultima pagina',
        nextPageLabel: 'Pagina successiva',
        previousPageLabel: 'Pagina precedente',
        rowsPerPageLabel: 'Righe per pagina',
        jumpToPageInputLabel: 'Vai alla pagina',
        selectRow: 'Riga selezionata',
        unselectRow: 'Riga deselezionata',
        expandRow: 'Riga espansa',
        collapseRow: 'Riga compressa',
        showFilterMenu: 'Mostra menu filtro',
        hideFilterMenu: 'Nascondi menu filtro',
        filterOperator: 'Operatore filtro',
        filterConstraint: 'Vincolo filtro',
        editRow: 'Modifica riga',
        saveEdit: 'Salva modifica',
        cancelEdit: 'Annulla modifica',
        listView: 'Vista elenco',
        gridView: 'Vista griglia',
        slide: 'Scorri',
        slideNumber: '{slideNumber}',
        zoomImage: 'Ingrandisci immagine',
        zoomIn: 'Ingrandisci',
        zoomOut: 'Riduci',
        rotateRight: 'Ruota a destra',
        rotateLeft: 'Ruota a sinistra'
      }
    });
  }
}

